import { StoreName } from "../../decorators/StoreNameDecorator";
import AcceleratorDoc from "../../models/AcceleratorDoc";
import API from "../../models/API";
import {
  BatchClassMetadata,
  BatchClassMetadataData,
} from "../../models/config/BatchClassMetadata";
import { AbstractRemovableStore } from "../RemovableStore";

@StoreName("BatchClassMetadataStore")
class BatchClassMetadataStoreClass extends AbstractRemovableStore<
  string,
  BatchClassMetadataData
> {
  storedObjectKeysEquals(a: string, b: string): boolean {
    return a === b;
  }

  async lookup(
    compositeKey: string,
  ): Promise<BatchClassMetadataData | undefined> {
    throw new Error("Method not implemented.");
  }

  getAll(): Array<BatchClassMetadataData> {
    const returnValues = this.values;
    return returnValues;
  }

  /**
   * Sync all batch class metadata. Does not Store
   */
  public static async syncAll(): Promise<BatchClassMetadataData[]> {
    let responseValue: any = await API.get("/v0/config")
      .then((value: Response) => value.json())
      .catch((error: string) => {
        console.log(error);
      });

    const metadatas: BatchClassMetadataData[] = [];

    if (!Array.isArray(responseValue)) responseValue = [];

    responseValue
      .map((x: any): BatchClassMetadata | null => {
        try {
          return new BatchClassMetadata(x);
          // return x;
        } catch (e) {
          console.error(e);
          return null;
        }
      })
      .filter((x: BatchClassMetadata | null) => x != null)
      .forEach((x: BatchClassMetadata) => metadatas.push(x));

    return metadatas;
  }

  //@ts-expect-error
  _vamp(values) {
    //@ts-expect-error
    this.values = values.map((r) => new AcceleratorDoc(r));
  }
  _unvamp() {
    return this.values;
  }
}

const BatchClassMetadataStore = new BatchClassMetadataStoreClass();
export { BatchClassMetadataStore, BatchClassMetadataStoreClass };
